export default __webpack_public_path__ + "60159b369b595bbb6dcae80f1e9e1e3f.svg";